// Import any necessary dependencies
import { put, call, takeLatest, all, select } from "redux-saga/effects";
import loginUserWatcher from "./loginUserSaga";
import getUserWatcher from "./getUserSaga";
import getFutureEmployerWatcher from "./getFutureEmployerSaga";
import { watchUserActions } from "./userSagas";
import getConfigDataWatcher from "./getConfigDataSaga";
export default function* rootSaga() {
  yield all([
    loginUserWatcher(),
    getUserWatcher(),
    watchUserActions(),
    getFutureEmployerWatcher(),
    getConfigDataWatcher(),
  ]);
}
